import { useQuery } from 'react-query';

import { getUseQueryDataUndefinedErrorMessage } from '@/page-src/prequalification/pages/loans/utils/error-message';
import { getRankDeposits } from '@/page-src/product/pages/deposits/api';
import { useSavingsProductGuidContext } from '@/src/@domain/savings/hooks/use-savings-guid-context';
import { API_PATH } from '@/src/constants/api-path';

export const useGetDepositsRank = () => {
  const productGuid = useSavingsProductGuidContext();
  const { data } = useQuery([API_PATH.GET_RANK_DEPOSIT(productGuid)], () =>
    getRankDeposits(productGuid)
  );

  if (data === undefined) {
    throw new Error(getUseQueryDataUndefinedErrorMessage(getRankDeposits.name));
  }

  return data;
};
